import {faLink, faNote} from '@fortawesome/pro-regular-svg-icons'

import {FaIcon} from '@sdox/ui'

import {EditorFeature} from '../types'
import {useTipTapEditorContext} from '../EditorContext'
import {EditorControlButton} from './EditorControlButton'
import {ControlGroup} from './ControlGroup'
import {FootNoteSelect} from '../FootNoteSelect'

const features = [
  EditorFeature.link,
  EditorFeature.footnote,
]

export const ComplexControls = () => {
  const {editor, toggleLinkDialog, toggleFootnoteDialog, showFootnoteDialog} = useTipTapEditorContext()

  return (
    <ControlGroup features={features}>
      <EditorControlButton
        active={editor.isActive('link')}
        feature={EditorFeature.link}
        trailing={<FaIcon icon={faLink} />}
        onClick={toggleLinkDialog}
        title={'Add/edit hyperlink'}
      />
      <div className={'relative'}>
        <EditorControlButton
          active={editor.isActive('footnote') || showFootnoteDialog}
          feature={EditorFeature.footnote}
          onClick={() => toggleFootnoteDialog()}
          trailing={<FaIcon icon={faNote}/>}
          title={'Add/edit footnote'}
        />
        {showFootnoteDialog ? <FootNoteSelect/> : null}
      </div>
    </ControlGroup>
  )
}
